import { GithubOutlined, MailFilled, QqOutlined, WechatOutlined } from '@ant-design/icons'
import { QRCode } from 'antd'
import Footer from 'rc-footer'
import 'rc-footer/assets/index.css'
import React from 'react'
import '../common/fun.css'

export default function Foot() {
  return (
    <Footer
      backgroundColor='#F1F3FA'
      style={{
        lineHeight: 1.5,
      }}
      columns={[
        {
          style: { margin: '0px' },
          title: '相关作品',
          items: [{
            icon: (
              <img src="logo.png" alt='' />
            ),
            title: '趣标签页',
            url: 'https://funtabs.cn',
            description: '高度可定制的个性导航'
          },
          ]
        }, {
          style: { margin: '0px' },
          title: '服务提供',
          items: [
            {
              icon: (
                <img src="/images/netlify.png" alt='' />
              ),
              title: 'Netlify',
              url: 'https://www.netlify.com',
              description: '网站托管服务'
            }, {
              icon: <GithubOutlined />,
              title: 'Github',
              url: 'https://github.com/dengxiwang',
              description: '@dengxiwang'
            },
          ]
        }, {
          style: { margin: '0px' },
          title: '联系我们',
          items: [
            {
              icon: <MailFilled />,
              title: '联系邮箱：admin@funtabs.cn',
              LinkComponent: 'div'
            }, {
              icon: <QqOutlined />,
              title: 'QQ群：727809499',
              url: 'https://qm.qq.com/cgi-bin/qm/qr?k=6N9Y0wlXF5txRjJcBqSYByj0fDsNwjIs&authKey=ziF+0yZBKLQB8GFFDJEHTXMaz35chgIPb88v98Vwdytvym5UlNMWOBOEwMAEHlMj&noverify=0',
            }, {
              icon: <WechatOutlined />,
              title: '微信公众号：funtabs趣标签页',
              LinkComponent: 'div'
            },
          ]
        }, {
          style: { margin: '0px' },
          title: '关注公众号',
          items: [
            {
              title: (
                <QRCode
                  errorLevel="H"
                  value="http://weixin.qq.com/r/fziEnP-E-qKBrbv-921t"
                  icon="logo.png"
                  style={{ display: 'contents' }}
                />
              ),
              LinkComponent: 'div'
            }
          ]
        }
      ]}
      theme='light'
      bottom={
        <div className='hardware-acceleration' style={{ backgroundColor: '' }}>
          <div style={{ opacity: '0.4' }}>Made with ❤️ by</div>
          <div>funtabs趣标签页｜不同标签页面，相同有趣好玩～</div>
        </div>
      } />
  )
}
